<template>
  <div class="instagram">
      <div class="ib" v-for='inst in instaArr.DATA' :key='inst.LINK' v-bind:style="{backgroundImage:'url('+inst.IMG+')',height:h+'px'}"><a target="_blank" v-bind:style="{height:h+'px'}" :href="inst.LINK"></a></div>
    </div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'
const urlInsta = 'https://andreykolesnikov.com/inwidget/'
export default {
  name: 'Instagram',
  data() {
    return {
      instaArr: [],
      h: 0
    };
  },
  mounted() {
    axios.get(urlInsta).then(response => {
      this.instaArr = response.data
      var box = document.querySelector('.instagram');
      var he=0;
      if(box.clientWidth<800){
        he=box.clientWidth/2;
      }
      else{
        he=box.clientWidth/4;
      }
      this.h=he;

    });
    
  }
}
</script>